module.exports = __webpack_public_path__ + "img/continue_icon.771b51e9.svg";